import { render } from "./RawMaterialAmount.vue?vue&type=template&id=16d4d656"
import script from "./RawMaterialAmount.vue?vue&type=script&lang=js"
export * from "./RawMaterialAmount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__